import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import Utils from "../../helper/utils";

export const NotFound = () => {
  Utils.setDocumentTitle("Página não encontrada");

  return (
    <div className='CentralizedContainer' >
         <img src='/NotFound.gif' alt='Not Found' width='1920' height='1080'/>        
    </div>
  );
};
